import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { Space, Row, Col, Button } from "antd"
import { Link } from "gatsby"

import "./PlanCardMini.less"

const PlanCardMini = ({ planId }) => {
  const { t } = useTranslation()

  const { period, priceLabel, paymentMode } = useMemo(() => {
    // GATSBY_BRAINTREE_SUBSCRIPTION_MONTHLY_PLAN_ID
    // GATSBY_BRAINTREE_SUBSCRIPTION_SEASONAL_PLAN_ID
    // GATSBY_BRAINTREE_SUBSCRIPTION_ANNUAL_PLAN_ID
    const periods = {
      [process.env.GATSBY_BRAINTREE_SUBSCRIPTION_MONTHLY_PLAN_ID]:
        t("label:monthly"),
      [process.env.GATSBY_BRAINTREE_SUBSCRIPTION_SEASONAL_PLAN_ID]:
        t("label:seasonal"),
      [process.env.GATSBY_BRAINTREE_SUBSCRIPTION_ANNUAL_PLAN_ID]:
        t("label:annual"),
    }

    const priceLabels = {
      [process.env.GATSBY_BRAINTREE_SUBSCRIPTION_MONTHLY_PLAN_ID]: t(
        "plan:subscription.monthly.priceLabel"
      ),
      [process.env.GATSBY_BRAINTREE_SUBSCRIPTION_SEASONAL_PLAN_ID]: t(
        "plan:subscription.seasonal.priceLabel"
      ),
      [process.env.GATSBY_BRAINTREE_SUBSCRIPTION_ANNUAL_PLAN_ID]: t(
        "plan:subscription.annual.priceLabel"
      ),
    }

    const paymentModes = {
      [process.env.GATSBY_BRAINTREE_SUBSCRIPTION_MONTHLY_PLAN_ID]: t(
        "plan:subscription.monthly.paymentModeLabelCompact"
      ),
      [process.env.GATSBY_BRAINTREE_SUBSCRIPTION_SEASONAL_PLAN_ID]: t(
        "plan:subscription.seasonal.paymentModeLabelCompact"
      ),
      [process.env.GATSBY_BRAINTREE_SUBSCRIPTION_ANNUAL_PLAN_ID]: t(
        "plan:subscription.annual.paymentModeLabelCompact"
      ),
    }

    return {
      period: periods[planId] || t("label:annual"),
      priceLabel:
        priceLabels[planId] || t("plan:subscription.annual.priceLabel"),
      paymentMode:
        paymentModes[planId] || t("plan:subscription.annual.paymentModeLabelCompact"),
    }
  }, [])

  const priceParts = priceLabel.split(
    process.env.GATSBY_DECIMAL_SEPARATOR || "."
  )

  return (
    <div className="plan-card-mini">
      <div className="price-container">
        <h2 className="period">{period}</h2>
        <Space direction="horizontal" align="start">
          <div className="price">{priceParts[0]}</div>
          <div className="payment-mode" direction="vertical" size={0}>
            <b>
              {process.env.GATSBY_DECIMAL_SEPARATOR || "."}
              {priceParts[1]}
            </b>
            <p>{paymentMode}</p>
          </div>
        </Space>
      </div>
      <Link to={`/auth/sign-up?planId=${planId}`}>
        <Button
          block
          className="yellowsp"
          style={{ marginTop: 21 }}
          size="small"
        >
          {t("button:chooseThisPlan")}
        </Button>
      </Link>
    </div>
  )
}

export default PlanCardMini
